import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, Select, Typography, DatePicker, DateTimePicker, message, Modal, InputNumber, MainModal, useProTableOt, ProTableOt, Accordion, AccordionItem, AccordionTrigger, AccordionContent, UploadAudio, UploadImg, Spin, Checkbox, Switch, TimeSelector, formatDateToTimeZone, RangePicker, ImportButton, useCRUDController } from "./../ui/ot";
import { useTranslation } from 'react-i18next';
import { useRecord } from './controller/record_controller';
import dayjs from 'dayjs';
import { useClassSetting } from "./controller/class_setting_controller"
import { PlusOutlined } from "@ant-design/icons";
const LanguageContext = createContext(null)

const ShiftStaffOverview = ({
    keyPrefix = "shift_management.shift_overview",
    propsForm,
    defaultValue = {},
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    customColumns = [],
    customDefaultColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseRecord = useRecord,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsOnValuesChange = () => { },
    propsShowKeys = [
        { key: "record_id", name: "record_id", hidden: false, require: false },
        { key: "date", name: "date", hidden: true, require: false },
        { key: "class_name", name: "class_name", hidden: false, require: false },
        { key: "class_working_start_time", name: "class_working_start_time", hidden: false, require: false },
        { key: "class_working_end_time", name: "class_working_end_time", hidden: false, require: false },
        { key: "is_flexible", name: "is_flexible", hidden: false, require: false },
        { key: "duration", name: "duration", hidden: false, require: false },
        { key: "is_rutine", name: "is_rutine", hidden: false, require: false },
        { key: "time_start", name: "time_start", hidden: false, require: false },
        { key: "time_end", name: "time_end", hidden: false, require: false },
        { key: "actions", name: "actions", hidden: false, require: false },
        { key: "record_time_data", name: "record_time_data", hidden: false, require: false },
    ],
    propsScheduleShowKeys = [
        { key: "teacher_id", name: "教師姓名", hidden: false, require: false },
        { key: "dec_1st", name: "12/1（日）", hidden: false, require: false },
        { key: "dec_2nd", name: "12/2（一）", hidden: false, require: false },
        { key: "dec_3rd", name: "12/3（二）", hidden: false, require: false },
        { key: "dec_4th", name: "12/4（三）", hidden: false, require: false },
        { key: "dec_5th", name: "12/5（四）", hidden: false, require: false },
        { key: "dec_6th", name: "12/6（五）", hidden: false, require: false },
        { key: "dec_7th", name: "12/7（六）", hidden: false, require: false },
        { key: "dec_8th", name: "12/8（日）", hidden: false, require: false },
        { key: "dec_9th", name: "12/9（一）", hidden: false, require: false },
        { key: "dec_10th", name: "12/10（二）", hidden: false, require: false },
        { key: "dec_11th", name: "12/11（三）", hidden: false, require: false },
        { key: "dec_12th", name: "12/12（四）", hidden: false, require: false },
        { key: "dec_13th", name: "12/13（五）", hidden: false, require: false },
        { key: "dec_14th", name: "12/14（六）", hidden: false, require: false },
        { key: "dec_15th", name: "12/15（日）", hidden: false, require: false },
        { key: "dec_16th", name: "12/16（一）", hidden: false, require: false },
        { key: "dec_17th", name: "12/17（二）", hidden: false, require: false },
        { key: "dec_18th", name: "12/18（三）", hidden: false, require: false },
        { key: "dec_19th", name: "12/19（四）", hidden: false, require: false },
        { key: "dec_20th", name: "12/20（五）", hidden: false, require: false },
        { key: "dec_21st", name: "12/21（六）", hidden: false, require: false },
        { key: "dec_22nd", name: "12/22（日）", hidden: false, require: false },
        { key: "dec_23rd", name: "12/23（一）", hidden: false, require: false },
        { key: "dec_24th", name: "12/24（二）", hidden: false, require: false },
        { key: "dec_25th", name: "12/25（三）", hidden: false, require: false },
        { key: "dec_26th", name: "12/26（四）", hidden: false, require: false },
        { key: "dec_27th", name: "12/27（五）", hidden: false, require: false },
        { key: "dec_28th", name: "12/28（六）", hidden: false, require: false },
        { key: "dec_29th", name: "12/29（日）", hidden: false, require: false },
        { key: "dec_30th", name: "12/30（一）", hidden: false, require: false },
        { key: "dec_31st", name: "12/31（二）", hidden: false, require: false },
    ],
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const [shifts, setShifts] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [schedule_extra_columns, set_schedule_extra_columns] = useState([]);
    const actionRef = useRef();
    const defaultColumns = [
        {
            title: t('record_id'),
            dataIndex: 'record_id',
            key: 'record_id',
            align: "center",
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: t('date'),
            dataIndex: 'date',
            key: 'date',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: t('class_name'),
            dataIndex: 'class_name',
            key: 'class_name',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.class_name}
            </>)
        },
        {
            title: t('class_working_start_time'),
            dataIndex: 'class_working_start_time',
            key: 'class_working_start_time',
            sorter: true,
            width: "10rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.class_working_start_time}
            </>)
        },
        {
            title: t('class_working_end_time'),
            dataIndex: 'class_working_end_time',
            key: 'class_working_end_time',
            sorter: true,
            width: "10rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.class_working_end_time}
            </>)
        },
        {
            title: t('is_flexible'),
            dataIndex: 'is_flexible',
            key: '彈性排班',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.彈性排班}
            </>)
        },
        {
            title: t('is_rutine'),
            dataIndex: 'is_rutine',
            key: '重複排程',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.duration}
            </>)
        },
        {
            title: t('is_rutine'),
            dataIndex: 'is_rutine',
            sorter: true,
            width: "10rem",
            canFilter: true,
            filterType: "search",
            key: '重複排程',
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.重複排程}
            </>)
        },
        {
            title: t('time_start'),
            dataIndex: 'time_start',
            key: 'time_start',
            sorter: true,
            width: "12rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.time_start}
            </>)
        },
        {
            title: t('time_end'),
            dataIndex: 'time_end',
            key: 'time_end',
            sorter: true,
            width: "12rem",
            canFilter: true,
            filterType: "search",
            render: (_, record) => (<>
                {record?.record_class_data?.find(_ => true)?.time_end}
            </>)
        },
    ];
    const columns = [
        ...customColumns,
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
    ]
    const defaultScheduleColumns = [
        {
            title: '教師姓名',
            dataIndex: 'teacher_id',
            key: 'teacher_id',
            align: "center",
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/1（日）',
            dataIndex: 'dec_1th',
            key: 'dec_1th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/2（一）',
            dataIndex: 'dec_2th',
            key: 'dec_2th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/3（二）',
            dataIndex: 'dec_3th',
            key: 'dec_3th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/4（三）',
            dataIndex: 'dec_4th',
            key: 'dec_4th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/5（四）',
            dataIndex: 'dec_5th',
            key: 'dec_5th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/6（五）',
            dataIndex: 'dec_6th',
            key: 'dec_6th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/7（六）',
            dataIndex: 'dec_7th',
            key: 'dec_7th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/8（日）',
            dataIndex: 'dec_8th',
            key: 'dec_8th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/9（一）',
            dataIndex: 'dec_9th',
            key: 'dec_9th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/10（二）',
            dataIndex: 'dec_10th',
            key: 'dec_10th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/11（三）',
            dataIndex: 'dec_11th',
            key: 'dec_11th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/12（四）',
            dataIndex: 'dec_12th',
            key: 'dec_12th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/13（五）',
            dataIndex: 'dec_13th',
            key: 'dec_13th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/14（六）',
            dataIndex: 'dec_14th',
            key: 'dec_14th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/15（日）',
            dataIndex: 'dec_15th',
            key: 'dec_15th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/16（一）',
            dataIndex: 'dec_16th',
            key: 'dec_16th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/17（二）',
            dataIndex: 'dec_17th',
            key: 'dec_17th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/18（三）',
            dataIndex: 'dec_18th',
            key: 'dec_18th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/19（四）',
            dataIndex: 'dec_19th',
            key: 'dec_19th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/20（五）',
            dataIndex: 'dec_20th',
            key: 'dec_20th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/21（六）',
            dataIndex: 'dec_21st',
            key: 'dec_21st',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/22（日）',
            dataIndex: 'dec_22nd',
            key: 'dec_22nd',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/23（一）',
            dataIndex: 'dec_23rd',
            key: 'dec_23rd',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/24（二）',
            dataIndex: 'dec_24th',
            key: 'dec_24th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/25（三）',
            dataIndex: 'dec_25th',
            key: 'dec_25th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/26（四）',
            dataIndex: 'dec_26th',
            key: 'dec_26th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/27（五）',
            dataIndex: 'dec_27th',
            key: 'dec_27th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/28（六）',
            dataIndex: 'dec_28th',
            key: 'dec_28th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/29（日）',
            dataIndex: 'dec_29th',
            key: 'dec_29th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/30（一）',
            dataIndex: 'dec_30th',
            key: 'dec_30th',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: '12/31（二）',
            dataIndex: 'dec_31st',
            key: 'dec_31st',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
    ];
    const schedule_columns = [
        ...customDefaultColumns,
        ...defaultScheduleColumns.filter(column => propsScheduleShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
    ]
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const [rangePickerSearch, setRangePickerSearch] = useState({})

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form_] = Form.useForm();
    const form = propsForm || form_;
    const [axiosMode, setAxiosMode] = useState("get")

    const [importData, setImportData] = useState([]);
    const [import_modal, set_import_modal] = useState(false);
    const [upload_modal, set_upload_modal] = useState(false)

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }

    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...record,
        })
    }

    const onFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values });
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reload();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }

    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                record_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    record_id: val?.record_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    deleteRecord(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postRecord([values])
        }
        else if (axiosMode === "patch") {
            patchRecord([values])
        }
    }

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.record_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.record_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.record_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.record_id)
                selectRow = selectRow.filter(row => row.record_id !== record.record_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }

    const setParamsFilter = (obj) => {
        obj = trimObjectArray([obj]).find(_ => true);
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const trimObjectArray = (data) => {
        return data.map(item => {
            // 创建一个新对象来避免修改原始对象
            const trimmedItem = {};
            for (const key in item) {
                if (Object.prototype.hasOwnProperty.call(item, key)) {
                    const value = item[key];
                    // 检查值是否为字符串
                    if (typeof value === 'string') {
                        trimmedItem[key] = value.trim();
                    } else {
                        trimmedItem[key] = value;
                    }
                }
            }
            return trimmedItem;
        });
    }

    const changeData = (record) => {
        let data_tmp = importData.filter(item => item.index != record.index);
        setImportData(data_tmp);
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })

    const {
        Record,
        getRecord,
        postRecord,
        patchRecord,
        deleteRecord,
        exportRecord,
        importRecord,
        downloadRecord,
        overRecord,
        getScheduleRecord,
    } = propsUseRecord({
        onBefore,
        onFinish
    })

    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <ProTableOt
                        actionRef={actionRef}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...rangePickerSearch,
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                ...filter,
                                order,
                                size: params?.pageSize,
                                cur_page: params?.current,
                                custom_filter_value: params?.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            return getRecord(newParams)
                        }}
                        rowKey={'record_id'}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        scroll={{
                            x: "max-content"
                        }}
                        toolBarRender={() => toolBarRender([
                            <Button className='example' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={e => exportRecord({ 'record_id_arr': selectedRowKeys })}>{t("export")}</Button>,
                            <ImportButton
                                handleDownload={e => downloadRecord()}
                                handleImport={e => { e['columns'] = columns; importRecord(e) }}
                                set_upload_modal={set_upload_modal}
                                upload_modal={upload_modal}
                                importData={importData}
                                setImportData={setImportData}
                                import_modal={import_modal}
                                set_import_modal={set_import_modal}
                                handleReserve={e => patchRecord(e)}
                                handleOver={e => overRecord(e)}
                                columns={[...columns, {
                                    title: '保留/覆蓋',
                                    align: 'center',
                                    render: (text, record, index) => {
                                        if (record.type == 'name') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { changeData(record) }}>保留</Button>
                                                </>)
                                        } else if (record.type == 'both') {
                                            return (
                                                <>
                                                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => { patchRecord([record]); changeData(record) }}>覆蓋</Button>
                                                </>
                                            )
                                        }
                                    }
                                }]}
                            />,
                        ])}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            setSelectedRowKeys: setSelectedRowKeys,
                            selectedRowsInfo: selectedRowsInfo,
                            setSelectedRowsInfo: setSelectedRowsInfo,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <div className="space-y-4">
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.P style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.P>
                                    </span>
                                </div>
                            );
                        }}
                        defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                        defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                        axiosMode={axiosMode}
                        propsUseData={() => {
                            return {
                                postData: (data) => {
                                    let datas = [...data]
                                    datas = datas.map((values) => {
                                        return values
                                    })
                                    postRecord(datas)
                                },
                                patchData: (data) => {
                                    patchRecord(data);
                                },
                                deleteData: deleteRecord,
                            }
                        }}
                        propsPatchOnFinish={({ axiosMode, status }) => {
                            if (status === "success") {
                                actionRef.current.reload()
                            } else {

                            }
                        }}
                        PropsPatchForm={<ShiftForm
                            keyPrefix={keyPrefix}
                            propsShowKeys={[
                                { key: "record_id", name: "record_id", hidden: false, require: false },
                                { key: "date", name: "date", hidden: true, require: false },
                                { key: "class_name", name: "class_name", hidden: false, require: false },
                                { key: "class_working_start_time", name: "class_working_start_time", hidden: false, require: false },
                                { key: "class_working_end_time", name: "class_working_end_time", hidden: false, require: false },
                                { key: "is_flexible", name: "is_flexible", hidden: false, require: false },
                                { key: "duration", name: "duration", hidden: false, require: false },
                                { key: "is_rutine", name: "is_rutine", hidden: true, require: false },
                                { key: "time_start", name: "time_start", hidden: false, require: false },
                                { key: "time_end", name: "time_end", hidden: false, require: false },
                                { key: "actions", name: "actions", hidden: false, require: false },
                            ]}
                        />}
                        propsPatchOnBefore={() => { }}
                        propsPatch
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        propsDelete
                        propsPost
                        propsWidth={1000}
                    />
                </Col>
            </Row>
            {/* <Row gutter={[8, 8]}>
                <Col span={24}>
                    <ProTableOt
                        actionRef={actionRef}
                        columns={schedule_columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                ...filter,
                                order,
                                size: params?.pageSize,
                                cur_page: params?.current,
                                custom_filter_value: params?.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });

                            return getScheduleRecord(newParams)
                        }}
                        rowKey={'teacher_id'}
                        extra_columns={schedule_extra_columns}
                        set_extra_columns={set_schedule_extra_columns}
                        manage_columns={false}
                        scroll={{
                            x: "max-content"
                        }}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <div className="space-y-4">
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.P style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.P>
                                    </span>
                                </div>
                            );
                        }}
                        defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                        defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                    />
                </Col>
            </Row> */}
        </>
    );
};
const ShiftForm = ({
    keyPrefix = "shift_management.shift_overview",
    propsForm,
    formReloadCount = 0,
    field,
    fieldName = field?.name,
    defaultValue = [],
    propsOnValuesChange = () => { },
    onFormFinish = () => { },
    customFormItems = () => { },
    propsShowKeys = [
        { key: "record_id", name: "record_id", hidden: false, require: false },
        { key: "date", name: "date", hidden: false, require: false },
        { key: "class_name", name: "class_name", hidden: false, require: false },
        { key: "class_working_start_time", name: "class_working_start_time", hidden: false, require: false },
        { key: "class_working_end_time", name: "class_working_end_time", hidden: false, require: false },
        { key: "is_flexible", name: "is_flexible", hidden: false, require: false },
        { key: "duration", name: "duration", hidden: false, require: false },
        { key: "is_rutine", name: "is_rutine", hidden: false, require: false },
        { key: "time_start", name: "time_start", hidden: false, require: false },
        { key: "time_end", name: "time_end", hidden: false, require: false },
        { key: "actions", name: "actions", hidden: false, require: false },
    ],
    mode = "timeselector",
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [isFlexible, setIsFlexible] = useState()
    const [timeRange, setTimeRange] = useState()
    const [customSelectedTimes, setCustomSelectedTimes] = useState()
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const [currentKey_, setCurrentKey] = useState([])
    const currentKey = propsShowKeys ?? currentKey_;
    const ClassSettingRef = useRef([]);
    const calculateMinutesBetween = (time1, time2) => {
        // 將時間字串轉換為 Date 物件
        const [hours1, minutes1, seconds1] = time1?.split(":").map(Number);
        const [hours2, minutes2, seconds2] = time2?.split(":").map(Number);

        // 使用今天的日期，設置不同的時間
        const date1 = new Date();
        date1.setHours(hours1, minutes1, seconds1);

        const date2 = new Date();
        date2.setHours(hours2, minutes2, seconds2);

        // 計算時間差，並轉換為分鐘
        const differenceInMilliseconds = date1 - date2;
        const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));

        return differenceInMinutes;
    }
    const formatTime = (time) => {
        const [hours, minutes] = time?.split(":"); // 分割時間，僅取小時和分鐘
        return `${hours}:${minutes}`;
    };
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        form.setFieldsValue(newFormValues)
    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getClassSetting()
        setIsFlexible(form.getFieldValue('record_class_data.0.is_flexible'))
    }

    const onValuesChange = (e, { name, ...props }) => {
        let formValues = getFormValues();
        if (String(name).indexOf("is_flexible") !== -1) {
            setIsFlexible(form.getFieldValue(name))
            if (form.getFieldValue(name) == 0) {
                setFormValuesOtherThings(
                    {
                        [fieldName ? [fieldName, 'record_class_data.0.is_flexible'].join('.') : 'record_class_data.0.is_flexible']: 0,
                    }
                )
            } else {
                const classSetting = ClassSettingRef.current.find(_ => _.class_id == form.getFieldValue(name))
                setFormValuesOtherThings(
                    {
                        [fieldName ? [fieldName, 'record_class_data.0.duration'].join('.') : 'record_class_data.0.duration']: calculateMinutesBetween(classSetting?.class_working_end_time, classSetting?.class_working_start_time),
                    }
                )
            }
        }

        if (String(name).indexOf("class_id") !== -1) {
            const classSetting = ClassSettingRef.current.find(_ => _.class_id == form.getFieldValue(name))
            setFormValuesOtherThings(
                {
                    [fieldName ? [fieldName, 'record_class_data.0.duration'].join('.') : 'record_class_data.0.duration']: calculateMinutesBetween(classSetting?.class_working_end_time, classSetting?.class_working_start_time),
                    // [fieldName ? [fieldName, 'record_class_data.0.time_range'].join('.') : 'record_class_data.0.time_range']: `${formatTime(classSetting?.class_working_start_time)}-${formatTime(classSetting?.class_working_end_time)}`,
                }
            )
        }
        propsOnValuesChange(formValues, { name, ...props })
    }

    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }

    const onBefore = ({ axiosMode, status, values }) => {
        // [MODULE] 在 onBefore 開始前先傳回給串接人
        // setModalLoading(true)
    }
    const {
        ClassSetting,
        getClassSetting
    } = useClassSetting({
    })

    useEffect(() => {
        setDataInitialization();
    }, [])

    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        ClassSettingRef.current = ClassSetting
    }, [ClassSetting])

    useEffect(() => {
        if (defaultValue !== null && defaultValue.length !== 0) {
            form.setFieldsValue(defaultValue);
            setIsFlexible(defaultValue?.['record_class_data']?.find(_ => true)?.['is_flexible']);
        }
    }, [defaultValue])

    useEffect(() => {
        if (defaultValue !== null && defaultValue.length !== 0) {
            form.setFieldsValue(defaultValue);
            onValuesChange(defaultValue, { name: '' })
            setIsFlexible(defaultValue?.['record_class_data']?.find(_ => true)?.['is_flexible']);
        }
    }, [])

    const is_rutine = Form.useWatch(field?.name+'.is_rutine', form)
    const selectableRanges = Form.useWatch(field?.name+'.selectableRanges', form) ?? ["00:00-24:00"]
    const date = Form.useWatch(field?.name+'.date', form)
    return (<>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_id"].join('.') : "record_id"}
                                label={t('record_id')}
                                hidden
                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}>

                            <Form.Item
                                name={fieldName ? [fieldName, "date"].join('.') : "date"}
                                label={t('date')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "date"
                                        })?.require,
                                        message: "請選擇排班時間"
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "date"
                                })?.hidden}
                            >
                                <DatePicker.Time format={'YYYY-MM-DD'} granularity="day" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.is_rutine"].join('.') : "record_class_data.0.is_rutine"}
                                label={t('is_rutine')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "is_rutine"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "is_rutine"
                                })?.hidden}
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.duration"].join('.') : "record_class_data.0.duration"}
                                label={t('duration')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "duration"
                                        })?.require,
                                        message: '請填寫'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "duration"
                                })?.hidden}
                            >
                                <InputNumber disabled={true} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.is_flexible"].join('.') : "record_class_data.0.is_flexible"}
                                label={t('is_flexible')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "is_flexible"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "is_flexible"
                                })?.hidden}
                            >
                                <Switch mode={'number'} />
                            </Form.Item>
                        </Col>
                        <Col span={24} hidden={isFlexible == 0 ? false : true}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.class_id"].join('.') : "record_class_data.0.class_id"}
                                label={t('class_name')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "class_name"
                                        })?.require,
                                        message: '請選擇' + t('class_name')
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "class_name"
                                })?.hidden}
                            >
                                <Select options={ClassSetting?.map(item => (
                                    {
                                        value: item?.class_id,
                                        label: item?.class_name
                                    }
                                ))} />
                            </Form.Item>
                        </Col>
                        <Col span={24} hidden={isFlexible == 1 ? false : true}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.time_start"].join('.') : "record_class_data.0.time_start"}
                                label={t('time_start')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "time_start"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "time_start"
                                })?.hidden}
                            >
                                <DatePicker.Time
                                    granularity="day"
                                    placeholder={t("time_start")}
                                    format={'YYYY-MM-DD'}
                                />

                            </Form.Item>
                        </Col>
                        <Col span={24} hidden={isFlexible == 1 ? false : true}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_class_data.0.time_end"].join('.') : "record_class_data.0.time_end"}
                                label={t('time_end')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "time_end"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "time_end"
                                })?.hidden}
                            >
                                <DatePicker.Time
                                    granularity="day"
                                    placeholder={t("time_end")}
                                    format={'YYYY-MM-DD'}
                                />
                            </Form.Item>
                        </Col>
                        {mode === "timeselector" && <Col
                            span={24}
                            hidden={isFlexible == 1 ? false : true}
                        >
                            <Form.Item
                                name={fieldName ? [fieldName, "record_time_data"].join('.') : "record_time_data"}
                                label={t('time_end')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "record_time_data"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "record_time_data"
                                })?.hidden}
                            >
                                <TimeSelector
                                    slotInterval={60} // 設定為 60 分鐘時間槽
                                    initialSelectedTimes={[]}
                                    initialDisabledTimes={[]}
                                    selectableRanges={selectableRanges}  // 可選範圍
                                    maxHours={null} // 最大選擇上限設為 4 小時
                                />
                            </Form.Item>
                        </Col>}
                        {mode === "timeinput" && <Col span={24}>
                            <Form.Item
                                name={fieldName ? [fieldName, "record_time_data"].join('.') : "record_time_data"}
                                label={t('time_end')}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "record_time_data"
                                        })?.require,
                                        message: '請選擇'
                                    }
                                ]}
                                hidden={currentKey?.find((element) => {
                                    return element.name === "record_time_data"
                                })?.hidden}
                            >
                                <TimeInput
                                    date={date}
                                />
                            </Form.Item>
                        </Col>}
                        {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
    );
};
export { ShiftForm }
export default ShiftStaffOverview;

const TimeInput = (
    {
        initialSelectedTimes = [],    // 已選時間陣列
        initialDisabledTimes = [],    // 不可選時間陣列
        slotInterval = 60,            // 時間槽間隔，預設為 60 分鐘
        maxHours,                  // 最大選擇時數上限
        selectableRanges = ["00:00-23:59"],  // 可選範圍
        customSelectedTimes = [],
        setCustomSelectedTimes = () => { },
        onChange = () => { },
        onValueChange = () => { },
        name,
        value,
        date = dayjs().format('YYYY-MM-DD')
    }
) => {
    const dates = value.length > 0 ? value.map(range => {
        if (range) {
            const [rangeStart, rangeEnd] = range?.split("-").map(t => new Date(`${dayjs(date).format('YYYY-MM-DD')}T${t}:00`));
            return [rangeStart, rangeEnd]
        }
    }) : []
    return <>
        <RangePicker
            value={dates}
            mode={'time'}
            onValueChange={(value) => {
                if (dayjs(value.target.value?.[0]).isBefore(dayjs(value.target.value?.[1]))) {
                    if (value.target.value.length > 0) onValueChange({
                        target: {
                            name,
                            value: [dayjs(value.target.value?.[0]).format('HH:mm') + "-" + dayjs(value.target.value?.[1]).format('HH:mm')]
                        }
                    })
                    else onValueChange({
                        target: {
                            name,
                            value: []
                        }
                    })
                }
            }}
            onChange={(value) => {
                if (dayjs(value.target.value?.[0]).isBefore(dayjs(value.target.value?.[1]))) {
                    if (value.target.value.length > 0) onChange({
                        target: {
                            name,
                            value: [dayjs(value.target.value?.[0]).format('HH:mm') + "-" + dayjs(value.target.value?.[1]).format('HH:mm')]
                        }
                    })
                    else onChange({
                        target: {
                            name,
                            value: []
                        }
                    })
                }
            }}
        />
    </>
}
